import React from 'react';
import Button from '../forms/simple/Button';

export default function ModalToolbar({ title, onClose, tooltip }) {
	return <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '20px' }} >
		<h2 className="title-a" style={{ paddingTop: '8px', paddingBottom: '8px' }}>{title}</h2>
		{onClose != null && <Button iconText={<span style={{ fontSize: '1.6em' }}>&times;</span>} onClick={onClose} label="Sluiten" tooltip={tooltip} />}
	</div>;
}
